(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/shared/assets/javascripts/jackpot-helpers.js') >= 0) return;  svs.modules.push('/components/content/shared/assets/javascripts/jackpot-helpers.js');
"use strict";


var TAGLINE_GUARANTEED = 'alltid minst';
var TAGLINE_JACKPOT = 'ca';
var currencyInMillions;
if (svs.isServer) {
  var trinidad = require('trinidad-core').core;
  currencyInMillions = trinidad.components.require('utils', 'format').api.CurrencyInMillions;
} else {
  currencyInMillions = svs.utils.format.CurrencyInMillions;
}
function formatCurrencyTest(amount) {
  return parseFloat(currencyInMillions(amount).replace(',', '.').replace(' ', ''));
}
function formatAmountString(amount) {
  return "".concat(currencyInMillions(amount), " miljon").concat(formatCurrencyTest(amount) !== 1 ? 'er' : '', " kr");
}
function formatAmountStringShort(amount) {
  return "".concat(currencyInMillions(amount), " milj kr");
}
var processJackpotData = function processJackpotData(jackpotList) {
  var formattedList = [];
  for (var i = 0; i < jackpotList.length; i++) {
    var productJackpot = jackpotList[i];
    for (var j = 0; j < productJackpot.guaranteedJackpots.length; j++) {
      var o = productJackpot.guaranteedJackpots[j];
      var jackpotAmountString = "".concat(TAGLINE_GUARANTEED, " ").concat(formatAmountString(o.jackpotAmountSek));
      var jackpotAmountStringShort = "".concat(TAGLINE_JACKPOT, " ").concat(formatAmountStringShort(o.jackpotAmountSek));
      formattedList.push({
        productId: productJackpot.productId,
        productName: productJackpot.productName,
        drawNumber: productJackpot.drawNumber,
        description: o.description,
        jackpotAmount: o.jackpotAmountSek,
        jackpotAmountEuro: o.currency && o.currency.match(/euro/i) ? o.jackpotAmount : undefined,
        defaultJackpot: true,
        tagline: TAGLINE_GUARANTEED,
        jackpotAmountString: jackpotAmountString,
        jackpotAmountStringShort: jackpotAmountStringShort,
        guaranteedJackpotAmount: o.jackpotAmountSek,
        guaranteedJackpotAmountString: jackpotAmountString,
        guaranteedJackpotAmountStringShort: jackpotAmountStringShort
      });
    }
    for (var _j = 0; _j < productJackpot.jackpots.length; _j++) {
      var _o = productJackpot.jackpots[_j];
      var existsInList = false;
      for (var k = 0; k < formattedList.length; k++) {
        if (formattedList[k].drawNumber === productJackpot.drawNumber && (Boolean(formattedList[k].description.match(new RegExp("^".concat(_o.description), 'i'))) || Boolean(formattedList[k].productName.match(new RegExp("^".concat(_o.description), 'i'))))) {
          formattedList[k].jackpotAmount = _o.jackpotAmount;
          formattedList[k].windiv = _o.windiv;
          formattedList[k].defaultJackpot = false;
          formattedList[k].tagline = TAGLINE_JACKPOT;
          formattedList[k].jackpotAmountString = "".concat(TAGLINE_JACKPOT, " ").concat(formatAmountString(_o.jackpotAmount));
          formattedList[k].jackpotAmountStringShort = "".concat(TAGLINE_JACKPOT, " ").concat(formatAmountStringShort(_o.jackpotAmount));
          existsInList = true;
          break;
        }
      }
      if (!existsInList) {
        formattedList.push({
          productId: productJackpot.productId,
          productName: productJackpot.productName,
          drawNumber: productJackpot.drawNumber,
          description: _o.description,
          jackpotAmount: _o.jackpotAmount,
          defaultJackpot: false,
          tagline: TAGLINE_JACKPOT,
          jackpotAmountString: "".concat(TAGLINE_JACKPOT, " ").concat(formatAmountString(_o.jackpotAmount)),
          jackpotAmountStringShort: "".concat(TAGLINE_JACKPOT, " ").concat(formatAmountStringShort(_o.jackpotAmount)),
          windiv: _o.windiv
        });
      }
    }
  }
  return formattedList;
};
function replaceSweChars(stringToFix) {
  return stringToFix.replace('å', 'a').replace('ä', 'a').replace('ö', 'o');
}
var filterByProducts = function filterByProducts(products, jackpots) {
  if (products.length) {
    var filteredJackpots = [];
    var _loop = function _loop(i) {
      var jackpotList = jackpots.filter(function (j) {
        if (typeof products[i] === 'string' && products[i] === 'dromvinsten') {
          return false;
        }
        if (typeof products[i] === 'string') {
          return replaceSweChars(j.productName.toLowerCase()) === replaceSweChars(products[i]).toLowerCase();
        } else if (typeof products[i] === 'number') {
          return j.productId === products[i];
        }
        return false;
      });
      filteredJackpots = filteredJackpots.concat(jackpotList);
    };
    for (var i = 0; i < products.length; i++) {
      _loop(i);
    }
    return filteredJackpots;
  }
  return jackpots;
};
if (svs.isServer) {
  exports.processJackpotData = processJackpotData;
  exports.filterByProducts = filterByProducts;
} else {
  setGlobal('svs.content.shared.jackpotHelpers', {
    processJackpotData: processJackpotData,
    filterByProducts: filterByProducts
  });
}

 })(window);